export const canUseDom = () => typeof window !== "undefined";

export const showLoad = (loading: boolean): boolean => canUseDom() && loading;
